import { Video as IVideo } from "@/api/models/video";
import { VideoList as IVideoList } from "@/api/models/video-list";
import video from "@/getinfo-api/video";
import { VuexVideoListParams as IVuexVideoListParams } from "@/plugins/custom-interface";

export default {
  namespaced: true,
  state: {
    listenerRecords: [] as Array<IVideo>,
    listenerRecordsCount: 0
  },
  actions: {
    async GET_RECORDS(ctx: any, params: IVuexVideoListParams) {
      let response = await video(params);
      if (params.type === "listener") {
        ctx.commit("SET_LISTENER_RECORDS", response.data);
      }
    }
  },
  mutations: {
    SET_LISTENER_RECORDS(state: any, list: IVideoList) {
      state.listenerRecords = [...state.listenerRecords, ...list.videos];
      state.listenerRecordsCount = list.count;
    },
    CLEAR(state: any) {
      state.listenerRecords = [];
      state.listenerRecordsCount = 0;
    }
  },
  getters: {
    LISTENER_RECORDS(state: any) {
      return state.listenerRecords;
    },
    LISTENER_RECORDS_COUNT(state: any) {
      return state.listenerRecordsCount;
    }
  }
};
